package com.arenaproplay.admin.ui.components.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.arenaproplay.admin.ui.theme.AppColors
import com.arenaproplay.admin.ui.theme.bodySMedium
import com.arenaproplay.admin.ui.theme.toRgbString
import org.jetbrains.compose.web.css.*

/**
 * Deterministic avatar bubble — renders a circle with a gradient background
 * derived from [seed] using [AppColors.AvatarPalette], and shows [initials] centred.
 *
 * Pass the entity id (user, club, chat …) as [seed] so the same entity always
 * gets the same gradient colour across all tables and drawers.
 *
 * Derive [initials] locally in the calling page — each entity type uses
 * slightly different logic (name words vs email local-part vs username char).
 */
@Composable
fun AvatarBubble(
    seed: String,
    initials: String,
    sizePx: Int = 28,
) {
    val gradient = AppColors.AvatarPalette[
        kotlin.math.abs(seed.hashCode()) % AppColors.AvatarPalette.size
    ]
    val fontSize = (sizePx * 0.38f).toInt().coerceAtLeast(9)
    Box(
        Modifier
            .width(sizePx.px)
            .minWidth(sizePx.px)
            .height(sizePx.px)
            .borderRadius(50.percent)
            .styleModifier {
                property("background", gradient)
                property("flex-shrink", "0")
            },
        contentAlignment = Alignment.Center,
    ) {
        SpanText(
            initials,
            Modifier.bodySMedium()
                .styleModifier {
                    property("color", AppColors.Surface.toRgbString())
                    property("font-weight", "700")
                    property("font-size", "${fontSize}px")
                    property("line-height", "1")
                }
        )
    }
}
